import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { BadgeCheck } from "lucide-react";
import { SectionHead } from "./SectionHead";
import { Stars } from "./Stars";
import { API } from "@/lib/api";

const fmt = (iso) => new Intl.DateTimeFormat("fr-FR", { timeZone: "Europe/Paris", dateStyle: "long" }).format(new Date(iso));

export const Reviews = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${API}/reviews`).then(({ data: d }) => setData(d)).catch(() => {});
  }, []);

  if (!data || data.count === 0) return null;

  return (
    <section id="avis" data-testid="reviews-section" className="section bg-ice-soft">
      <div className="container-x">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8">
          <SectionHead eyebrow="Avis clients vérifiés" title="Avis de nos clients" />
          <div data-testid="reviews-summary" className="flex items-center gap-4 bg-white border border-slate-200 rounded-2xl px-6 py-4">
            <span data-testid="reviews-average" className="font-display text-4xl font-extrabold text-slate-900">{data.average.toLocaleString("fr-FR")}</span>
            <div className="flex flex-col gap-1">
              <Stars value={data.average} size="w-5 h-5" />
              <span data-testid="reviews-count" className="text-sm text-slate-500">{data.count} avis vérifié{data.count > 1 ? "s" : ""}</span>
            </div>
          </div>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 mt-10">
          {data.reviews.map((r) => (
            <article key={r.review_id} data-testid={`review-card-${r.review_id}`} className="benefit-card flex flex-col gap-3">
              <div className="flex items-center justify-between gap-3">
                <Stars value={r.rating} />
                <span className="inline-flex items-center gap-1 text-xs font-semibold text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-full px-2.5 py-1">
                  <BadgeCheck className="w-3.5 h-3.5" /> Achat vérifié
                </span>
              </div>
              <h3 className="font-display text-lg font-bold text-slate-900">{r.title}</h3>
              <p className="text-slate-600 leading-relaxed text-[15px] whitespace-pre-line">{r.comment}</p>
              <span className="text-sm text-slate-500 mt-auto pt-2">{r.display_name} — {fmt(r.created_at)}</span>
            </article>
          ))}
        </div>
        <p data-testid="reviews-notice" className="text-xs text-slate-500 mt-6 max-w-3xl">
          Avis collectés auprès de clients ayant acheté et reçu le produit, modérés par ClimNova avant publication ; avis négatifs publiés au même titre que positifs.{" "}
          <Link to="/charte-des-avis" data-testid="reviews-charter-link" className="text-sky-700 underline underline-offset-4">Charte des avis</Link>
        </p>
      </div>
    </section>
  );
};
